import styled from 'styled-components';
import { StyledCustomCard } from '@rsos/components/capstone/DataCards/CustomRenderer.styles';
import Box from '@rsos/components/capstone/base/Box';

export const StyledCard = styled(StyledCustomCard)`
  border: 1px solid
    ${({ theme }) => {
      return theme.colors?.name === 'dark'
        ? theme.colors?.heavyLineOutline
        : theme.colors?.lightLineDivider;
    }};
  ${({ borderless }) => borderless && `border: 0;`}
  border-radius: 5px;
  padding-top: 0;
  padding-bottom: ${({ isCollapsed }) => (isCollapsed ? 20 : 0)}px;
  margin-bottom: ${({ isCollapsed, summarized }) =>
    isCollapsed ? 15 : summarized ? 16 : 12}px;

  ${({ theme, summarized }) => {
    if (summarized) {
      return `
      cursor: pointer;
      &:last-child {
        margin-bottom: 0;
      }
      &:hover {
        background: ${theme.colors.foreground};
      }
    `;
    }
  }}
`;

export const StyledSubHeaderArea = styled(Box).attrs({ p: 3, pt: 0 })`
  font-size: 12px;
`;

export const MAFID = styled(Box).attrs({ mb: 3 })`
  font-weight: bold;
  color: ${({ theme }) => theme.colors.primaryText};
`;

export const StyledCardBody = styled.div`
  position: relative;
  overflow-y: auto;
  min-height: 16px; // to compensate for possible padding top and/or bottom in single line scenarios
  ${({ isAviveRequest }) => isAviveRequest && `min-height: 32px;`}
`;

export const DataPanel = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  background: ${({ theme }) => theme.colors.background};
  width: 100%;
  min-height: 100%;
`;

export const DataPanelContent = styled.div`
  padding: 0 20px;
`;

export const BackButton = styled.button`
  font-size: 12px;
  padding: 5px;
  background: ${({ theme }) => theme.colors.transparent};
  outline: 0;
  border: 0;
  border: 1px solid ${({ theme }) => theme.colors.primaryBase};
  color: ${({ theme }) => theme.colors.primaryBase};
  border-radius: 4px;
  cursor: pointer;
`;

export const StyledText = styled.div`
  line-height: 1.2;
  text-align: center;
  color: ${({ theme }) => theme.colors.primaryText};
`;
